export const filterOptions: FilterOption[] = [
  'client',
  'tags',
  'proposal-status',
  'acceptance',
  'validity',
  'date',
];
